import * as React from 'react'

import { CardInsertModel } from 'app/models/cardInsertModel'
import { CardActivityType } from 'app/constants/cardActivityType'

import { useScene } from '../context/SceneContext'
import { BOTTOM_PADDING } from '../utils/layout'

export type CardInsertBlockProps = {
  cardInsert: CardInsertModel
  index: number
}

const lineColor = '#C0C0C0'
const color = '#FF6A88'

const drawInserted = () => {
  return (
    <svg width={10} height={10} style={{ marginLeft: 3, marginBottom: -30 }}>
      <path d="M0 0 L5 6 L10 0" style={{ fill: color }} />
    </svg>
  )
}

const drawNotInserted = () => {
  return (
    <svg width={10} height={10} style={{ marginLeft: -12, marginBottom: -30 }}>
      <path d="M 0,6 5,0 10,6" style={{ fill: color }} />
    </svg>
  )
}

export const CardInsertBlock: React.FC<CardInsertBlockProps> = React.memo(
  (props: CardInsertBlockProps) => {
    const scene = useScene()

    const { cardInsert } = props
    const left = scene.timeToX(cardInsert.startTime)
    const HEIGHT = scene.height
    const height = HEIGHT - 40

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left,
          top: 0,
          bottom: 0,
          position: 'absolute',
          paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div style={{ width: 1 }}>
          {cardInsert.activityType === CardActivityType.INSERTED
            ? drawInserted()
            : drawNotInserted()}
          <div
            style={{
              background: lineColor,
              height,
              width: 2,
              marginBottom: 15,
              zIndex: 0,
            }}
          />
        </div>
      </div>
    )
  },
)

CardInsertBlock.displayName = 'CardInsertBlock'
